import script from "./ForecastAccuracyTableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForecastAccuracyTableCell.vue?vue&type=script&lang=ts&setup=true"

import "./ForecastAccuracyTableCell.vue?vue&type=style&index=0&id=0500d932&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0500d932"]])

export default __exports__